const headerMapping: Record<string, string> = {
  ATON: 'AtoN Name',
  CFA: 'Continuity Failure (%)',
  COK: 'Continuity OK (%)',
  CWA: 'Continuity Warning (%)',
  MSGCS: 'Continuity State',
  FA: 'Failure (%)',
  OK: 'OK (%)',
  VIT: 'AtoN Type',
  WA: 'Warning (%)',
  EDATS: 'End Date',
  SDATS: 'Start Date',
  OP: 'Off Position',
  STATE: 'State',
};

export const remapHeaders = (data: any[]): any[] => {
  return data.map((item) => {
    const newItem: any = {};

    // Iterate through keys in their current order (not Object.entries)
    Object.keys(item).forEach((key) => {
      const newKey = headerMapping[key] || key;
      // Use Object.defineProperty to maintain order
      Object.defineProperty(newItem, newKey, {
        value: item[key],
        enumerable: true,
        writable: true,
        configurable: true,
      });
    });

    return newItem;
  });
};
